/* eslint-disable no-console */
/* eslint-disable import/first */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate } from '@reach/router';
import { useIntl, FormattedMessage } from 'react-intl';
const {
  selectCountryValidations,
  selectHomeBaseURL,
  selectOrderModesByCountry,
} = Slices.configSlice;
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Button, Input } from '@material-ui/core';
import filter from 'lodash/filter';
const { selectCurrentCountry } = Slices.profileSlice;
const { setInsrtuction, getQRValue, qrCodeStatus } = Slices.appSlice;
const { fetchStore } = Slices.storeSlice;
const { selectAllMain } = Slices.categorySlice;
const { sendCart, clearCart } = Slices.cartSlice;
const { clearCustomizeItems } = Slices.tempCartSlice;
const { selectFirstMenu } = Slices.menuSlice;

import { Context } from '../../components/Multi-lang/Wrapper';
import Skeleton from 'react-loading-skeleton';
import QRSkelton from './QRSkelton';
const { postAddressPickup, choseStore } = Slices.addressSlice;
import { StoreIcon, Table, Car } from '../Icons';
import css from './index.module.scss';
import DialogBox from '../DialogBox';
import DrawerPwa from '../../components/DrawerPwa';
import {
  storeSelectionAttemptGA,
  storeSelectionFailureGA,
  storeSelectionSuccessGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import { capitalizeFirstLetter } from 'spwa-ui-library/esm/utils/helper';
const { selectLoginStatus } = Slices.authSlice;

export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));

export default function QrCodeRender({ onClose }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cartDropPopup, setCartDropPopup] = useState(false);
  const menu = useSelector(selectFirstMenu);
  // const { storeId, countryId, type, extraDetails } = qrValue;
  const store = useSelector((state) => state.store);
  const cart = useSelector((state) => state.cart);
  const profile = useSelector((state) => state.profile);
  const config = useSelector((state) => state.config);
  const [storeInfo, setStoreInfo] = useState(null);
  const context = useContext(Context);
  const homeBaseURL = useSelector(selectHomeBaseURL);
  const user = useSelector(selectLoginStatus);
  const qrValues = useSelector(getQRValue);
  const { storeId, countryId, type, extraDetails, status: qrStatus } = qrValues;
  const [instr, setInstr] = useState(extraDetails);
  const [storeError, setStoreError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [exploreLink, setExploreLink] = useState(null);
  const categories = useSelector(selectAllMain);
  const [loadShimmer, setLoadShimmer] = useState(false);
  const country = useSelector(selectCurrentCountry);
  const orderModes = useSelector((state) => selectOrderModesByCountry(state, country));
  const lang = intl.locale.split('-')[0].toLowerCase();

  // const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, countryId));
  useEffect(() => {
    if (store.status === 'idle' && config.status === 'succeeded') {
      dispatch(fetchStore({ country: countryId.toLowerCase() }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.status, config.status]);
  const newLanguage = capitalizeFirstLetter(lang);
  const qrType = type.toLowerCase();
  const OrderMode = {
    fromstore: {
      addressSubType: 'STORE',
      addressType: 'PICKUP',
      image: countryValidations?.storeQRPopupData.image[newLanguage],
      instr: countryValidations?.storeQRPopupData.instr,
      detailEnabled: false,
      orderButton: <FormattedMessage id="order_now" defaultMessage="Order Now" />,
    },
    carhop: {
      addressSubType: 'CARHOP',
      addressType: 'PICKUP',
      image: countryValidations?.storeQRPopupData.image[newLanguage],
      detailEnabled: true,
      heading: (
        <FormattedMessage
          id="enter_vehicle_details"
          defaultMessage="Please enter your vehicle details for in-car delivery"
        />
      ),
      placeholder: countryValidations?.carHopInstrPlaceholder,
      icon: <Car />,
      sub: <FormattedMessage id="40_max_char" defaultMessage="40 Max Character" />,
      maxLen: 40,
      example: countryValidations?.carHopInstrNode,
      orderButton: <FormattedMessage id="submit_continue" defaultMessage="Submit & Continue" />,
    },
    dinein: {
      addressSubType: 'DINEIN',
      addressType: 'DINEIN',
      image: countryValidations?.storeQRPopupData.image[newLanguage],
      detailEnabled: true,
      heading: (
        <FormattedMessage
          id="enter_table_number"
          defaultMessage="Please enter your table number below"
        />
      ),
      placeholder: countryValidations?.dineInInstr?.placeholder,
      icon: <Table />,
      sub: <FormattedMessage id="3_max_digits" defaultMessage="3 max digits" />,
      maxLen: 3,
      example: countryValidations?.dineInInstr.note,
      orderButton: <FormattedMessage id="order_now" defaultMessage="Order Now" />,
    },
    drivethru: {
      addressSubType: 'DRIVETHRU',
      addressType: 'DRIVETHRU',
      image: countryValidations?.storeQRPopupData.image[newLanguage],
      instr: countryValidations?.storeQRPopupData.instr,
      detailEnabled: false,
      orderButton: <FormattedMessage id="order_now" defaultMessage="Order Now" />,
    },
  };

  useEffect(() => {
    if (qrStatus === 'added' && store.status === 'succeeded') {
      const storeVal = filter(store.entities, (store) => store.storeId === +storeId);
      setStoreInfo((prev) => storeVal[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrStatus, store.status]);
  const handleButton = (e) => {
    if (cart.data.items.length) {
      mergeCart();
    }
    e.preventDefault();
    dispatch(setInsrtuction(instr));
    onClose(getOrderModeDisableStatus());
    navigate(exploreLink);
  };
  const getOrderModeDisableStatus = () => {
    const orderModeIndex = orderModes.findIndex(
      (element) => element.type === OrderMode[qrType]?.addressSubType
    );
    return !orderModes[orderModeIndex]?.enable;
  };

  useEffect(() => {
    if (getOrderModeDisableStatus()) {
      onClose(getOrderModeDisableStatus());
    }
    // else {
    //   onClose();
    // }
  }, [qrType]);

  useEffect(() => {
    if (
      store.status === 'succeeded' &&
      profile.status === 'succeeded' &&
      storeInfo &&
      qrStatus === 'added'
    ) {
      // if (menu.menuTempId !== storeInfo.menuTempId) {
      //   setCartDropPopup(true);
      // } else {
      renderStoreDetail();
      // }
    } else {
      setLoadShimmer(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrStatus, profile.status, storeInfo]);

  const renderStoreDetail = () => {
    const checkMode = getOrderModeDisableStatus();
    setCartDropPopup(false);
    if (!checkMode) {
      const payload = {
        addressSubType: OrderMode[qrType]?.addressSubType.toUpperCase(),
        addressType: OrderMode[qrType]?.addressType.toUpperCase(),
        addressVia: 'DEFAULT',
        areaId: storeInfo?.areaId,
        storeId: storeInfo?.storeId,
      };
      dispatch(
        choseStore({
          city: `${storeInfo.sdmCountryId}_${storeInfo.cityId}`,
          store: storeInfo.id,
          instruction: instr,
        })
      );
      dispatch(postAddressPickup(payload))
        .then((resp) => {
          storeSelectionSuccessGA(user, qrValues, storeInfo);
          if (resp.error) {
            storeSelectionFailureGA(user, qrValues, storeInfo);
            setStoreError((prev) => true);
            setErrorMsg((prev) => resp.error.message);
            setLoadShimmer(true);
          } else {
            setStoreError((prev) => false);
            setLoadShimmer(true);
          }
        })
        .catch((error) => {
          storeSelectionFailureGA(user, qrValues, storeInfo);
          console.log(error);
        });
      //commented this code because model get auto close if there is another store selected
      // dispatch(qrCodeStatus({ status: 'shown' }));
      storeSelectionAttemptGA(user, qrValues, storeInfo);
    }
  };

  const mergeCart = () => {
    const items = cart.data.items;
    const payload = {
      body: {
        addressSubType: OrderMode[qrType]?.addressSubType.toUpperCase(),
        addressType: OrderMode[qrType]?.addressType.toUpperCase(),
        // addressId: address?.id || '',
        cartId: cart?.data?.cartId,
        applySurprisePromo: 0,
        clusterId: cart?.data?.clusterId || '',
        items: items || [],
        version: 'v20',
        orderType: OrderMode[qrType]?.addressType.toUpperCase(),
        storeId: storeInfo.id,
      },
      headers: { country: cart?.data?.country },
    };

    // if (
    //   items?.payload?.data?.data.menuId !== countryValidations?.defaultMenuId ||
    //   items?.payload?.data?.data.menuTemplateId !== countryValidations?.defaultMenuTempId
    // ) {
    //   dispatch(clearCart());
    //   dispatch(clearCustomizeItems());
    //   navigate(`/${intl.locale}/home`, { replace: true });
    // } else {
    dispatch(sendCart(payload)).then((res) => {});
    // }
  };
  const handleStore = () => {
    navigate('/' + OrderMode[qrType]?.addressSubType.toLowerCase());
  };
  useEffect(() => {
    const result = categories.length > 0 && categories?.sort((a, b) => a.position - b.position);
    const exploreMenuPath = `/${context?.locale}/${URLEncode(result?.[0]?.name)}/${
      result?.[0]?.id
    }`;
    setExploreLink(exploreMenuPath);
  }, [categories, context.locale, exploreLink]);
  if (!loadShimmer) {
    return <QRSkelton />;
  }
  let disableButton = false;

  if (OrderMode[qrType]?.detailEnabled) {
    if (!storeError && instr !== '') {
      disableButton = false;
    } else {
      disableButton = qrType === 'dinein' ? false : true;
    }
  } else if (!storeError) {
    disableButton = false;
  } else {
    disableButton = true;
  }
  const handleValue = (e) => {
    // if (qrType && e.target.value.length < 21) {
    setInstr(e.target.value);
    // } else {
    //   setInstr(e.target.value.substring(0, 20));
    // }
  };
  const onlyNumbers = (evt) => {
    if (qrType === 'dinein') {
      var ASCIICode = evt.which ? evt.which : evt.keyCode;
      if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) evt.preventDefault();
      return true;
    } else {
      return true;
    }
  };

  const handleDropPopup = () => {
    dispatch(qrCodeStatus({ status: 'shown' }));
    setCartDropPopup(false);
    onClose();
  };
  if (cartDropPopup) {
    return (
      <DialogBox
        title={intl.formatMessage({ id: 'DropPopup_changeLocation' })}
        size="sm"
        isOpen={cartDropPopup}
        onClose={handleDropPopup}
      >
        <div className={css.dropcart}>
          <div className={css.content}>{intl.formatMessage({ id: 'DropPopup_content' })}</div>
          <div className={css.action}>
            <Button onClick={handleDropPopup} variant="outlined">
              {intl.formatMessage({ id: 'DropPopup_buttonCancel' })}
            </Button>
            <Button onClick={() => renderStoreDetail()} variant="contained" color="primary">
              {intl.formatMessage({ id: 'DropPopup_buttonProceed' })}
            </Button>
          </div>
        </div>
      </DialogBox>
    );
  } else
    return (
      <DrawerPwa variant="temporary" anchor="bottom" open={true} onClose={() => onClose()}>
        <div className={css.root}>
          <div className={css.banner}>
            {!OrderMode[qrType] ? (
              <Skeleton count={1} className={css.Skeleton} height={300} />
            ) : (
              <LazyLoadImage
                src={`${homeBaseURL}${OrderMode[qrType]?.image}`}
                width="375"
                height="338"
                alt="banner"
                effect="blur"
                placeholder={<Skeleton count={1} width={375} height={338} />}
              />
            )}
          </div>
          <div className={css.storeInfo}>
            <div className={css.icon}>
              <StoreIcon />
            </div>
            <div className={css.store}>
              {storeInfo ? (
                <>
                  <h3>{storeInfo?.name_en}</h3>
                  <h5>{storeInfo?.address_en}</h5>
                </>
              ) : (
                <h3>No Store Found</h3>
              )}
              {storeError && <div className={css.error}>{errorMsg}</div>}
            </div>
          </div>
          <div className={css.storeDetail}>
            {OrderMode[qrType]?.instr?.map((value, i) => {
              return (
                <div className={css.instItem} key={i}>
                  <div className={css.instIcon}>
                    <img src={`${homeBaseURL}${value.image}`} width="42" alt="instruction icon" />
                  </div>
                  <div className={css.text}>{value.text}</div>
                </div>
              );
            })}
            {!storeError && OrderMode[qrType]?.detailEnabled && (
              <div className={css.detailInfo}>
                <div className={css.lableInput}>{OrderMode[qrType]?.heading}</div>
                <div className={css.field}>
                  <Input
                    inputProps={{ maxLength: OrderMode[qrType]?.maxLen || 999 }}
                    className={css.input}
                    placeholder={OrderMode[qrType]?.placeholder}
                    startAdornment={OrderMode[qrType]?.icon}
                    value={instr}
                    onChange={handleValue}
                    onKeyPress={(event) => onlyNumbers(event)}
                  />
                </div>

                <div className={css.carDetail}>
                  <div> {OrderMode[qrType]?.example}</div>
                  <div>{OrderMode[qrType]?.sub}</div>
                </div>
              </div>
            )}
            {!storeError ? (
              <Button
                variant="contained"
                disabled={disableButton}
                color="primary"
                onClick={handleButton}
              >
                {OrderMode[qrType]?.orderButton}
              </Button>
            ) : (
              <Button
                variant="contained"
                disabled={!storeError}
                color="primary"
                onClick={handleStore}
              >
                <FormattedMessage id="change_store" defaultMessage="Change Store" />
              </Button>
            )}
          </div>
        </div>
      </DrawerPwa>
    );
}
